module.exports = __webpack_public_path__ + "img/20240901_1.2d60cf46.jpg";